import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MemoryRoutingModule } from './memory-routing.module';
import { SharedModule } from '../shared/shared.module';
import { HammerModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { LightgalleryModule } from 'lightgallery/angular';
import { MemoryFolderAddComponent } from './memory-folder-add/memory-folder-add.component';
import { MemoryFolderListComponent } from './memory-list/memory-list.component';
import { MemoryListComponent } from './memory-details/memory-details.component';
import { PhotoVideoListComponent } from './photo-video-list/photo-video-list.component';

@NgModule({
  declarations: [
    MemoryFolderListComponent,
    MemoryListComponent,
    MemoryFolderAddComponent,
    PhotoVideoListComponent
  ],
  imports: [
    CommonModule,
    MemoryRoutingModule,
    SharedModule,
    HammerModule,
    HttpClientModule,
    LightgalleryModule
  ]
})
export class MemoryModule { }
